import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual, get } from 'lodash';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import Actions from '@redux/reports';
import { Table } from '@components';
import { transactionHistoryColumn } from '../utils/columnsDefinition';

class TransactionHistoryReport extends Component {
	constructor(props) {
		super(props);
		const TimeZoneId = get(this.props, ['TimeZoneId'], 'America/Chicago');
		this.state = {
			column : transactionHistoryColumn(this.viewDetailsFunction, TimeZoneId),
		};
	}

	shouldComponentUpdate = ({ transactionHistoryData, filterPrintData, TimeZoneId }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.transactionHistoryData, transactionHistoryData)
			|| !isEqual(lastProps.filterPrintData, filterPrintData)
			|| !isEqual(lastProps.TimeZoneId, TimeZoneId)
		);
	};

	componentWillUnmount = () => {
		const { resetReportsListData } = this.props;
		resetReportsListData();
	}

	viewDetailsFunction = (id) => {
		const { push } = this.props;
		push({ pathname : `/payments/receipt/${id}` });
	}

	showFilterDataForPrint = (filterPrintData) => (
		<Fragment>
			<div className="margin-top-10">
				<span className="color-dark font-regular report-table-header-title">Filters</span>
			</div>
			<Choose>
				<When condition={filterPrintData.length}>
					<For
						each="item"
						of={filterPrintData}
					>
						<div
							key={item.label}
							className="flex"
						>
							<span className="font-light color-gray-bayoux flex-1">{ item.label }</span>
							<span className="font-regular color-gray-bayoux flex-2">
								:
								{ item.value }
							</span>
						</div>
					</For>
				</When>
				<Otherwise>
					<span>No filter Applied</span>
				</Otherwise>
			</Choose>
		</Fragment>
	);

	render() {
		const { transactionHistoryData, filterPrintData } = this.props;
		const { column } = this.state;
		return (
			<Fragment>
				<div className="flex flex-direction-column margin-top-20">
					<span className="font-size-24 font-regular color-gray-oxford">Transaction History</span>
					<span className="font-size-16 font-regular color-gray-regent">You are viewing all your recent transactions</span>
				</div>
				<div className="show-print">
					{ this.showFilterDataForPrint(filterPrintData) }
				</div>
				<Table
					rowKey="TransactionId"
					className="compact-row header-hidden margin-top-50 bg-white"
					columns={column}
					data={transactionHistoryData}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	reports : {
		transactionHistoryData,
		filterPrintData,
	}, app: { user: { TimeZoneId } },
}) => ({
	transactionHistoryData,
	filterPrintData,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	push                 : bindActionCreators(pushAction, dispatch),
	resetReportsListData : bindActionCreators(Actions, dispatch).resetReportsListData,
});

TransactionHistoryReport.propTypes = {
	filterPrintData        : PropTypes.array,
	push                   : PropTypes.func.isRequired,
	resetReportsListData   : PropTypes.func.isRequired,
	transactionHistoryData : PropTypes.array,
	TimeZoneId             : PropTypes.string,
};

TransactionHistoryReport.defaultProps = {
	filterPrintData        : [],
	transactionHistoryData : [],
	TimeZoneId             : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionHistoryReport);
